module.exports = __webpack_public_path__ + "img/arrow_forward_ios.f5ab0d72.svg";